import moment from 'moment';
import { statuses } from 'constants/booking';

export const isComplaintEligible = (booking) =>
  !!booking &&
  booking.status === statuses.PAID &&
  moment().isSameOrBefore(booking.check_out, 'day');
